import {
  useNectarProject,
  useNectarProjects,
  useNectarProjectsUnauthorized,
  useNectarProjectUnauthorized
} from '@/features/nectar/api'
import { nectarProjectToMission } from '@/features/nectar/api/normalizer'
import { useMemo } from 'react'
import { NectarTask } from '../nectar/components/NectarTask'
import { useMission, useMissionsList, usePublicMission, usePublicMissionsList } from './api'
import { Mission } from './api/models'
import { MissionDetail } from './components/MissionDetail'
import { useMissionsUrl } from './context/MissionsUrlProvider'
import { Missions } from './Missions'

export const MissionsForAuthorizedUser = () => {
  const { missionsUrl, platform } = useMissionsUrl()
  const { data: missionsList, isFetching: isFetchingMissions } = useMissionsList({ platform })
  const { data: nectarData, isFetching: isFetchingNectar } = useNectarProjects()

  const isInitialLoad = (isFetchingMissions && !missionsList) || (isFetchingNectar && !nectarData)

  const availableMissions = useMemo(() => {
    const missions = missionsList ?? []
    const nectarMissions = (nectarData?.data ?? []).map((project) => nectarProjectToMission(project, missionsUrl))
    return [...nectarMissions, ...missions].toSorted((a, b) => a.sortOrder - b.sortOrder)
  }, [missionsList, nectarData, missionsUrl])

  return <Missions availableMissions={availableMissions} isInitialLoad={isInitialLoad} isAuthorized />
}

export const MissionsForUnauthorizedUser = () => {
  const { missionsUrl, platform } = useMissionsUrl()
  const { data: missionsList, isFetching: isFetchingMissions } = usePublicMissionsList({ platform })
  const { data: nectarData, isFetching: isFetchingNectar } = useNectarProjectsUnauthorized()

  const isInitialLoad = (isFetchingMissions && !missionsList) || (isFetchingNectar && !nectarData)

  const availableMissions = useMemo(() => {
    const missions = missionsList ?? []
    const nectarMissions = (nectarData?.data ?? []).map((project) => nectarProjectToMission(project, missionsUrl))
    return [...nectarMissions, ...missions].toSorted((a, b) => a.sortOrder - b.sortOrder)
  }, [missionsList, nectarData, missionsUrl])

  return <Missions availableMissions={availableMissions as Mission[]} isInitialLoad={isInitialLoad} />
}

export const MissionDetailForAuthorizedUser = ({ missionId }: { missionId: string }) => {
  const { data: mission, isFetching } = useMission(missionId)
  return <MissionDetail mission={mission} isFetching={isFetching} isAuthorized />
}

export const MissionDetailForUnauthorizedUser = ({ missionId }: { missionId: string }) => {
  const { data: mission, isFetching } = usePublicMission(missionId)
  return <MissionDetail mission={mission as Mission} isFetching={isFetching} />
}

export const NectarMissionDetailForAuthorizedUser = ({ missionId }: { missionId: string }) => {
  const { data: project, isLoading: isFetchingProject } = useNectarProject(missionId)

  return <NectarTask project={project} isFetchingProject={isFetchingProject} isAuthorized />
}

export const NectarMissionDetailForUnauthorizedUser = ({ missionId }: { missionId: string }) => {
  const { data: project, isLoading: isFetchingProject } = useNectarProjectUnauthorized(missionId)

  return <NectarTask project={project} isFetchingProject={isFetchingProject} isAuthorized={false} />
}
